export default __webpack_public_path__ + "static/more-4f4d32ff349af0c8ec7b417e6bf16ccd.jpg";